import { PublicClientApplication, LogLevel, BrowserCacheLocation, } from '@azure/msal-browser';
import { isIE } from '../compatiblity';
import { getSite } from '../baseSite';
/** Build an msal instance from a config
 *
 * @constant
 */
export const makeMsalFromConfig = (config) => {
    const authorityUrl = new URL(config.authority);
    const knownAuthorities = [authorityUrl.host];
    //adds the base path to support non-root react site
    const redirectUri = getSite('/auth/');
    const pcaConfig = {
        auth: {
            clientId: config === null || config === void 0 ? void 0 : config.clientId,
            authority: config === null || config === void 0 ? void 0 : config.authority,
            knownAuthorities,
            navigateToLoginRequestUrl: false,
            redirectUri,
            //extra options
            //cloudDiscoveryMetadata,
            //clientCapabilities
        },
        cache: {
            storeAuthStateInCookie: isIE(), //|| !isLocalStorageAvailable,
            cacheLocation: config && config.cachingType
                ? config.cachingType
                : BrowserCacheLocation.SessionStorage, // This configures where your cache will be stored
        },
        system: {
            navigateFrameWait: 2500,
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            // console.info(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                    }
                },
                piiLoggingEnabled: false,
            },
            // Set high so that silent frames don't expire too fast
            loadFrameTimeout: 15000,
            //extra options
            // windowHashTimeout: 60000,
            // loadFrameTimeout: 0,
            // asyncPopups: false,
        },
    };
    return new PublicClientApplication(pcaConfig);
};
